import React from 'react';
import PropTypes from 'prop-types';
import {Line} from 'react-chartjs-2';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    chartContainer: {
        position: 'relative'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    }
}));

const HistoryGraph = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();

    const {labels, ranks} = data;

    const getChartData = ({ranks}) => {
        const chartData = {
            datasets: [
                {
                    label: 'Rank',
                    type: 'scatter',
                    data: ranks,
                    fill: false,
                    borderColor: theme.palette.info.main,
                    backgroundColor: theme.palette.info.main,

                    pointBorderColor: theme.palette.info.dark,
                    pointBackgroundColor: theme.palette.info.dark,

                    pointHoverBackgroundColor: theme.palette.info.dark,
                    pointHoverBorderColor: theme.palette.info.dark,
                    yAxisID: 'y-axis-1'
                }
            ]
        };
        const chartOptions = {
            responsive: true,
            labels: labels,
            tooltips: {
                mode: 'nearest',
                callbacks: {
                    label: tooltipItem => `${tooltipItem.yLabel}위`
                },
            },
            elements: {
                line: {
                    fill: false
                }
            },
            scales: {
                xAxes: [
                    {
                        display: true,
                        gridLines: {
                            display: true
                        },
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 7,
                            maxRotation: 0,
                            minRotation: 0,
                            padding: 10,
                            callback: value => value.split(' ')[0] // TODO : refac
                        },
                        labels: labels
                    }
                ],
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                        gridLines: {
                            display: true
                        },
                        labels: {
                            show: true
                        },
                        ticks: {
                            reverse: true,
                            min: 1,
                            padding: 10
                        }
                    }
                ]
            }
        };

        const zoomOptions = {
            zoom: {
                pan: {
                    enabled: true,
                    mode: 'x'
                },
                zoom: {
                    enabled: true,
                    drag: true,
                    mode: 'x'
                }
            }
        };

        return {
            data: chartData,
            options: {
                ...chartOptions,
                plugins: {
                    zoom: zoomOptions
                }
            }
        };
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                title="D-30 Ranking History"
            />
            <Divider/>
            {ranks && (
                <CardContent>
                    <div className={classes.chartContainer}>
                        <Line {...getChartData({ranks})} />
                    </div>
                </CardContent>
            )}
        </Card>
    );
};

HistoryGraph.propTypes = {
    className: PropTypes.string,
    // data: PropTypes.object.isRequired
};

export default HistoryGraph;
